import isomorphicCookie from 'isomorphic-cookie'

export default () => {
  const accessToken = isomorphicCookie.load('accessToken', {
    secure: process.env.NODE_ENV === 'production',
  })

  if (accessToken) {
    // call introspect endpoint here.
    return '/'
  }

  return null
}
